<template lang="pug">
b-alert.validation-alert(v-model="_value" variant="danger" dismissible)
  div.mb-2 入力エラーがあります。ご確認ください。
  ul
    li(v-for="error in _alertErrors") {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 入力バリデーションエラー表示用のv-alert wrapper
 *
 * - 使用元コンポーネントで_veeValidateをインポートする必要がある
 */
@Component({})
export default class ValidationAlertByValidator extends Vue {
  @Inject("$validator") $validator!: Validator; // 親コンポーネントのバリデーターをInjectionする

  @Prop({ required: true })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _alertErrors(): string[] {
    const errors: string[] = [];
    for (const item of this.$validator.errors.items) {
      errors.push(item.msg);
    }
    return errors;
  }
}
</script>

<style lang="scss" scoped>
.validation-alert {
  width: 100%;
  margin-bottom: 0.5rem !important;
  ul {
    margin-bottom: 0 !important;
  }
}
</style>
